var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"uk-switcher uk-margin",attrs:{"id":"element-settings"}},[_c('li',{staticClass:"uk-active"},[_c('div',{staticClass:"uk-width-1-1"},[_c('p',[_vm._v("Keine weiteren Einstellungen")])])]),_c('li',[_c('div',{staticClass:"uk-width-1-1 uk-margin"},[_c('div',[_c('p',[_vm._v("Keine weiteren Einstellungen")])])])])])
}]

export { render, staticRenderFns }